import http from "@/services/http";

/**
 * Lista as restrições alimentares de um paciente (tabela patient_dietary_restrictions).
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>} lista (`{ id, restriction, notes, ... }`)
 */
export async function getRestrictionsByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-dietary-restrictions/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Catálogo de restrições alimentares (referência) — alimenta o select + "Outro".
 * @returns {Promise<Array<{id:number, name:string}>>}
 */
export async function getRestrictionCatalog() {
  const { data } = await http.get("/api/dietary-restriction-catalog");
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Adiciona uma ou várias restrições de uma vez ao paciente.
 *
 * @param {number|string} patientId
 * @param {object[]} restrictions lista `[{ restriction, notes? }]`
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function createRestrictions(patientId, restrictions) {
  return http.post("/api/patient-dietary-restrictions/create", {
    patient_id: patientId,
    restrictions: restrictions.map((r) => ({
      restriction: r.restriction,
      dietary_restriction_catalog_id: r.dietary_restriction_catalog_id || null,
      notes: r.notes || null,
    })),
  });
}

/**
 * Remove uma restrição do paciente (soft delete).
 *
 * @param {number} id
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export function deleteRestriction(id) {
  return http.delete(`/api/patient-dietary-restrictions/delete/${id}`);
}
